import styled, { css } from "styled-components";

import { Palette } from "./theme";

const TypographyStyles = css`
    &.aevi-text {
        font-family: "RobotoLight";
        font-size: 11pt;
        font-weight: 400;
        line-height: 28pt;
        color: ${Palette.AeviBlack};
    }

    &.aevi-label {
        font-family: "RobotoLight";
        font-size: 12pt;
        font-weight: 100;
        line-height: 18pt;
        color: ${Palette.AeviBlack};
        text-align: right;
    }

    &.aevi-brand-text {
        font-family: "AeviFont";
        font-size: 16pt;
        font-weight: 100;
        line-height: 32pt;
        margin-left: 10pt;
        padding-top: 11pt;
        color: ${Palette.HeroGreen};
    }

    &.aevi-title {
        font-family: "AeviFont";
        font-size: 24pt;
        font-weight: 400;
        line-height: 32pt;
        color: ${Palette.AeviBlack};
        margin-top: 0;
    }

    &.aevi-username {
        font-family: RegularFont, sans-serif;
        font-weight: normal;
        font-size: 11pt;
        line-height: 16pt;
        color: ${Palette.White};
        white-space: nowrap;
        margin-top: 2px;
    }

    &.aevi-datagroup {
        color: ${Palette.White};
        font-size: 12px;
        white-space: nowrap;
        font-family: RobotoLight, sans-serif;
        margin-top: 2px;
    }

    &.aevi-userdata-container {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        line-height: 1.1;
        text-align: right;
        height: 100%;
    }

    &.aevi-userdata-container > :only-child {
        margin-top: auto;
        margin-bottom: auto;
    }
`;

export const TextStyle = styled.p.attrs(() => ({ className: "aevi-text" }))`
    ${TypographyStyles};
`;

export const BrandTextStyle = styled.div.attrs(() => ({ className: "aevi-brand-text" }))`
    ${TypographyStyles};
`;

export const TitleStyle = styled.h1.attrs(() => ({ className: "aevi-title" }))`
    ${TypographyStyles};
`;

export const UserNameStyle = styled.div.attrs(() => ({ className: "aevi-username" }))`
    ${TypographyStyles};
`;

export const DataGroupNameStyle = styled.div.attrs(() => ({ className: "aevi-datagroup" }))`
    ${TypographyStyles};
`;

export const UserDataContainer = styled.div.attrs(() => ({ className: "aevi-userdata-container" }))`
    ${TypographyStyles};
`;
